import React, { useEffect, useState } from "react";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { FomrmLoginInput } from "../../LoginUser/styled/LoginStyles";
import {
	OrderPageInfomationTime,
	OrderPageInfomationTimeTitle,
	OrderPageInfomationTimeWrap,
} from "../../Order/styled/OrderStyle";
import DateRangeInput from "../../../controls/components/dateRangeInput/DateRangeInputOrder";
import { AdminFilterStoreControl } from "./FilterPartner";
import {
	BookingFilterSelect,
	InputOrderAdminTitle,
	OrderAdminSelectDisable,
	UserFormServiceButtonClose,
	UserFormServiceButtonCreated,
} from "../styled/DesStyled";
import useAddOrderAdmin from "../hook/AddOrderAdmin";
import {
	OrderMethod,
	OrderMethodLabelMap,
	OrderMethodList,
	OrderStatus,
	OrderStatusLabelMap,
} from "../../../../models/Order";
import { AdminFilterUserControl } from "./FilterUser";
import moment from "moment";
import { orderCalendarDateToPickerDate, toOrderCalendarDateInput } from "../../../../utils/orderCalendarDate";

// 16/10/2026: "Cancelled" left the edit form — cancelling here never refunded the customer
// yet emailed them "Refunded amount…". Cancel goes through "Cancel booking…" in the list.
const editableOrderStatuses = [OrderStatus.Pending, OrderStatus.Paid, OrderStatus.Finish];

function formatLocalDateInput(date: Date) {
	return toOrderCalendarDateInput(date);
}

export default function DialogAddOrderAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	reload: () => void;
}) {
	const [partner, setPartner] = useState(0);
	const [timeIn, setTimeIn] = useState("");
	const [timeOut, setTimeOut] = useState("");
	const [quantity, setQuantity] = useState("");
	const [paymentMethod, setPaymentMethod] = useState("1");
	const [totalMoney, setTotalMoney] = useState("");
	const [userId, setUserId] = useState(0);
	const { addOrderAd } = useAddOrderAdmin({ reload: props.reload });

	const handleSave = async () => { 
		if (new Date(timeIn) > new Date(timeOut)) {
			alert("Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc!");
			return;
		}
		await addOrderAd(partner, timeIn, timeOut, quantity, paymentMethod, totalMoney, userId);
		props.setOpenDialog(false);
	};
	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Add Order"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
				</>
			}>
			<InputOrderAdmin
				partner={partner}
				setPartner={setPartner}
				timeIn={timeIn}
				setTimeIn={setTimeIn}
				timeOut={timeOut}
				setTimeOut={setTimeOut}
				quantity={quantity}
				setQuantity={setQuantity}
				paymentMethod={paymentMethod}
				setPaymentMethod={setPaymentMethod}
				totalMoney={totalMoney}
				setTotalMoney={setTotalMoney}
				userId={userId}
				setUserId={setUserId}
			/>
		</DialogWrapMedium>
	);
}

export function InputOrderAdmin(props: {
	updateOrder?: boolean;
	partner?: number;
	partnerLabel?: string;
	setPartner: (value: number) => void;
	timeIn: string;
	setTimeIn: (value: string) => void;
	timeOut: string;
	setTimeOut: (value: string) => void;
	quantity: string;
	setQuantity: (value: string) => void;
	paymentMethod: string;
	setPaymentMethod: (value: string) => void;
	totalMoney: string;
	setTotalMoney: (value: string) => void;
	status?: string;
	setStatus?: (value: string) => void;
	userId: number;
	setUserId: (value: number) => void;
	timeInDate?: string;
	timeInTime?: Date;
	timeOutDate?: string;
	timeOutTime?: Date;
	openDialog?: boolean;
	/** 31/10/2026: super admin được lùi ngày về quá khứ (xem UpdateOrderAdmin) */
	minDate?: Date;
}) {
	const today = new Date();
	const tomorrow = new Date();
	tomorrow.setDate(today.getDate() + 1);
	const paymentMethodOptions = props.updateOrder
		? [OrderMethod.OnePay, OrderMethod.PayPal, OrderMethod.Stripe]
		: OrderMethodList;

	const formattedToday = formatLocalDateInput(today);
	const formattedTomorrow = formatLocalDateInput(tomorrow);
	const [dropOffDate, setDropOffDate] = useState<string>(props.timeInDate || formattedToday);
	const [dropOffTime, setDropOffTime] = useState<Date>(props.timeInTime || new Date());
	const [pickUpDate, setPickUpDate] = useState<string>(props.timeOutDate || formattedTomorrow);
	const [pickUpTime, setPickUpTime] = useState<Date>(props.timeOutTime || new Date());

	useEffect(() => {
		if (!dropOffDate) {
			props.setTimeIn("");
			return;
		}

		props.setTimeIn(dropOffDate);
	}, [dropOffDate, dropOffTime, props.openDialog]);

	useEffect(() => {
		if (!pickUpDate) {
			props.setTimeOut("");
			return;
		}

		props.setTimeOut(pickUpDate);
	}, [pickUpDate, pickUpTime, props.openDialog]);
	const dropOfffromDate = orderCalendarDateToPickerDate(dropOffDate) || new Date();
	const pickUptoDate = orderCalendarDateToPickerDate(pickUpDate) || new Date();
	// console.log("timeInDate",props.timeInDate)
	// console.log("timeInTime",props.timeInTime)
	useEffect(() => {
		if (props.timeInDate && props.timeInTime) {
			setDropOffDate(props.timeInDate);
			setDropOffTime(props.timeInTime);
		}
	}, [props.timeInDate, props.timeInTime, props.openDialog]);

	useEffect(() => {
		if (props.timeOutDate && props.timeOutTime) {
			setPickUpDate(props.timeOutDate);
			setPickUpTime(props.timeOutTime);
		}
	}, [props.timeOutDate, props.timeOutTime, props.openDialog]);
	

	return (
		<div>
			<InputOrderAdminTitle>Kiểu thanh toán</InputOrderAdminTitle>
			<BookingFilterSelect
				value={props.paymentMethod}
				onChange={(e) => props.setPaymentMethod(e.target.value)}>
				{paymentMethodOptions.map((method) => (
					<option
						key={method}
						value={method}>
						{OrderMethodLabelMap.get(method)}
					</option>
				))}
			</BookingFilterSelect>
			<InputOrderAdminTitle>Người đặt</InputOrderAdminTitle>
			<OrderAdminSelectDisable updateOrder={props.updateOrder}>
				<AdminFilterUserControl
					filterStaffId={props.userId}
					doChangeStaffId={props.setUserId}
				/>
			</OrderAdminSelectDisable>
			<InputOrderAdminTitle>Station</InputOrderAdminTitle>
			<OrderAdminSelectDisable>
				<AdminFilterStoreControl
					filterStaffId={props.partner}
					selectedLabel={props.partnerLabel}
					doChangeStaffId={props.setPartner}
				/>
			</OrderAdminSelectDisable>
			<InputOrderAdminTitle>Số lượng</InputOrderAdminTitle>
			<OrderAdminSelectDisable updateOrder={props.updateOrder}>
				<FomrmLoginInput
					placeholder="Quantity"
					value={props.quantity}
					onChange={(e) => props.setQuantity(e.target.value)}
					readOnly={!!props.updateOrder}
				/>
			</OrderAdminSelectDisable>
			<InputOrderAdminTitle>Tổng tiền</InputOrderAdminTitle>
			<OrderAdminSelectDisable updateOrder={props.updateOrder}>
				<FomrmLoginInput
					placeholder="Total Money"
					value={props.totalMoney}
					onChange={(e) => props.setTotalMoney(e.target.value)}
					readOnly={!!props.updateOrder}
				/>
			</OrderAdminSelectDisable>
			{props.updateOrder && props.setStatus && (
				<>
					<InputOrderAdminTitle>Trạng thái</InputOrderAdminTitle>
					<BookingFilterSelect
						value={props.status || ""}
						onChange={(e) => props.setStatus?.(e.target.value)}>
						{editableOrderStatuses.map((statusValue) => (
							<option
								key={statusValue}
								value={statusValue}>
								{OrderStatusLabelMap.get(statusValue)}
							</option>
						))}
					</BookingFilterSelect>
					<div style={{ fontSize: 12, color: "#6B7280", marginTop: 6 }}>
						To cancel, close this form and use <b>Cancel booking…</b> — it asks whether to refund the customer.
					</div>
				</>
			)}
			<OrderPageInfomationTimeWrap>
				<OrderPageInfomationTime>
					<OrderPageInfomationTimeTitle>Ngày bắt đầu</OrderPageInfomationTimeTitle>
					<DateRangeInput
						fromDate={dropOfffromDate}
						minDate={props.minDate}
						onDateFromChange={(date: Date | null) =>
							setDropOffDate(date ? formatLocalDateInput(date) : "")
						}
					/>
					{/* <TimeRangeInput
						fromTime={dropOffTime}
						onTimeFromChange={(date: Date | null) => {
							setDropOffTime(date ? date : new Date());
						}}
					/> */}
				</OrderPageInfomationTime>
				<OrderPageInfomationTime>
					<OrderPageInfomationTimeTitle>Ngày kết thúc</OrderPageInfomationTimeTitle>
					<DateRangeInput
						fromDate={pickUptoDate}
						minDate={props.minDate}
						onDateFromChange={(date: Date | null) =>
							setPickUpDate(date ? formatLocalDateInput(date) : "")
						}
					/>
					{/* <TimeRangeInput
						fromTime={pickUpTime}
						onTimeFromChange={(time: Date | null) => setPickUpTime(time ? time : new Date())}
					/> */}
				</OrderPageInfomationTime>
			</OrderPageInfomationTimeWrap>
		</div>
	);
}
